import { render, staticRenderFns } from "./Over.vue?vue&type=template&id=f920244e&scoped=true&"
var script = {}
import style0 from "./Over.vue?vue&type=style&index=0&id=f920244e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f920244e",
  null
  
)

export default component.exports